"use client"

import { usePathname } from "@opensea/navigation"
import { classNames } from "@opensea/ui-kit"
import { withSuspense } from "../suspense/WithSuspense"
import { useOnboardingGuard } from "./OnboardingGuard"

export const OnboardingFadeIn = withSuspense(function OnboardingFadeIn() {
  const pathname = usePathname()

  const { redirect } = useOnboardingGuard()
  if (!redirect) {
    return
  }

  return (
    <div
      className={classNames(
        "pointer-events-none fixed inset-0 z-onboarding-fade bg-black",
        "duration-2000 ease-out-circ",
        pathname !== "/onboard" && "opacity-0",
      )}
    />
  )
})
